export default {
  order: {
    title: "Заказ",
    pickupDate: "Дата подачи",
    pickup: "Место подачи",
    dropoff: "Место назначения",
    passenger: "Пассажир",
    comment: "Комментарий",
    vehicle: "Транспорт",
    chauffeur: "Водитель",
    passengersCount: "Пассажиры",
    childSeats: "Детские кресла",
    flightNumber: "Номер рейса",
    nameSign: "Табличка с именем",
    speaks: "Говорит на",
    call: "Позвонить",
    licensePlate: "Номерной знак",
    category: "Категория",
    status: {
      new: "Ожидание подтверждения",
      confirmed: "Заказ подтвержден",
      on_my_way: "Водитель в пути",
      at_the_location: "Водитель на месте",
      pob: "Пассажир в машине",
      clear: "Заказ завершен",
      no_show: "Пассажир не явился",
      canceled: "Заказ отменен"
    },
    statusDescriptions: {
      new: "Заказ ожидает подтверждения поставщиком",
      confirmed: "Поставщик подтвердил заказ, ожидание начала",
      on_my_way: "Водитель в пути к месту подачи",
      at_the_location: "Водитель прибыл и ждет пассажира",
      pob: "Пассажир сел в машину, в пути к месту назначения",
      clear: "Заказ успешно завершен",
      no_show: "Пассажир не появился в месте подачи",
      canceled: "Заказ отменен"
    },
    messages: {
      noChauffeurAssigned: "Ваш водитель еще не назначен",
      detailsWillAppear: "Детали появятся здесь после назначения",
      unknown: "Неизвестно",
      started: "Начато",
      awaitingAssignment: "Ожидание назначения"
    },
    childSeatsTypes: {
      child_01: "Люлька (6 месяцев)",
      child_02: "Детское кресло (0-7 лет)",
      child_03: "Бустер (6-12 лет)"
    },
    distance: "{distance} км",
    review: "Оцените свою поездку",
    review_status: {
      perfect: 'Отлично',
      good: 'Хорошо',
      average: 'Удовлетворительно',
      bad: 'Плохо',
      terrible: 'Ужасно'
    }
  },
  common: {
    save: "Сохранить",
    cancel: "Отмена",
    loading: "Загрузка...",
    error: "Ошибка"
  }
}